import React, { useEffect, useState } from 'react';
import { Menu, BookOpen, Settings } from 'lucide-react';
import { Sidebar } from './components/Sidebar';
import { FrameworkDetail } from './components/FrameworkDetail';
import { ThemeToggle } from './components/ThemeToggle';
import { FrameworksProvider, useFrameworks } from './context/FrameworksContext';
import { FrameworkEditor } from './components/cms/FrameworkEditor';
function AppContent() {
  const {
    frameworks
  } = useFrameworks();
  const [selectedId, setSelectedId] = useState<string | null>(null);
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);
  const [isCmsMode, setIsCmsMode] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editingId, setEditingId] = useState<string | null>(null);
  // Select the first framework by default on desktop
  useEffect(() => {
    if (!selectedId && window.innerWidth >= 768 && frameworks.length > 0) {
      setSelectedId(frameworks[0].id);
    }
  }, [selectedId, frameworks]);
  const selectedFramework = frameworks.find(f => f.id === selectedId) || null;
  const handleAddFramework = () => {
    setEditingId(null);
    setIsEditing(true);
    if (window.innerWidth < 768) setIsMobileSidebarOpen(false);
  };
  const handleEditFramework = (id: string) => {
    setEditingId(id);
    setIsEditing(true);
    if (window.innerWidth < 768) setIsMobileSidebarOpen(false);
  };
  const handleSaveFramework = (id: string) => {
    setIsEditing(false);
    setSelectedId(id);
  };
  return <div className="flex flex-col h-screen bg-white dark:bg-slate-950 text-slate-900 dark:text-slate-50 overflow-hidden font-sans transition-colors duration-200" data-id="element-0">
      {/* Top Header */}
      <header className={`flex-shrink-0 h-16 border-b bg-white dark:bg-slate-950 flex items-center justify-between px-4 md:px-6 z-20 relative transition-colors ${isCmsMode ? 'border-blue-500 border-b-2' : 'border-slate-200 dark:border-slate-800'}`} data-id="element-1">
        <div className="flex items-center" data-id="element-2">
          <button onClick={() => setIsMobileSidebarOpen(true)} className="mr-4 p-2 -ml-2 text-slate-500 hover:bg-slate-100 dark:hover:bg-slate-800 rounded-md md:hidden" data-id="element-3">
            <Menu className="w-5 h-5" data-id="element-4" />
          </button>
          <div className="flex items-center space-x-2" data-id="element-5">
            <div className={`p-1.5 rounded-lg text-white ${isCmsMode ? 'bg-indigo-600' : 'bg-blue-600'}`} data-id="element-6">
              <BookOpen className="w-5 h-5" data-id="element-7" />
            </div>
            <div data-id="element-8">
              <div className="flex items-center gap-2" data-id="element-9">
                <h1 className="font-bold text-lg leading-tight tracking-tight" data-id="element-10">
                  Storytelling Frameworks
                </h1>
                {isCmsMode && <span className="px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider bg-blue-100 text-blue-700 dark:bg-blue-900/50 dark:text-blue-300 rounded-full" data-id="element-11">
                    CMS Mode
                  </span>}
              </div>
              <p className="text-xs text-slate-500 dark:text-slate-400 hidden sm:block" data-id="element-12">
                Master the art of narrative structure
              </p>
            </div>
          </div>
        </div>

        <div className="flex items-center gap-2" data-id="element-13">
          <button onClick={() => {
          setIsCmsMode(!isCmsMode);
          if (isEditing) setIsEditing(false);
        }} className={`flex items-center gap-2 px-3 py-1.5 rounded-md text-sm font-medium transition-colors ${isCmsMode ? 'bg-blue-100 text-blue-700 dark:bg-blue-900/40 dark:text-blue-300' : 'text-slate-600 hover:bg-slate-100 dark:text-slate-300 dark:hover:bg-slate-800'}`} data-id="element-14">
            <Settings className="w-4 h-4" data-id="element-15" />
            <span className="hidden sm:inline" data-id="element-16">
              {isCmsMode ? 'Exit CMS' : 'Manage'}
            </span>
          </button>
          <div className="w-px h-6 bg-slate-200 dark:bg-slate-800 mx-1" data-id="element-17"></div>
          <ThemeToggle data-id="element-18" />
        </div>
      </header>

      {/* Main Layout */}
      <div className="flex flex-1 overflow-hidden relative" data-id="element-19">
        <Sidebar selectedId={selectedId} onSelect={id => {
        setSelectedId(id);
        setIsEditing(false);
      }} isOpen={isMobileSidebarOpen} onClose={() => setIsMobileSidebarOpen(false)} isCmsMode={isCmsMode} onAddFramework={handleAddFramework} onEditFramework={handleEditFramework} data-id="element-20" />

        <main className="flex-1 flex flex-col min-w-0 bg-white dark:bg-slate-950" data-id="element-21">
          {isCmsMode && isEditing ? <FrameworkEditor frameworkId={editingId} onSave={handleSaveFramework} onCancel={() => setIsEditing(false)} data-id="element-22" /> : <FrameworkDetail framework={selectedFramework} isCmsMode={isCmsMode} onEdit={() => handleEditFramework(selectedFramework?.id || '')} data-id="element-23" />}
        </main>
      </div>
    </div>;
}
export function App() {
  return <FrameworksProvider data-id="element-24">
      <AppContent data-id="element-25" />
    </FrameworksProvider>;
}